import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import 'vuetify/dist/vuetify.min.css'
import MasonryWall from '@yeger/vue2-masonry-wall'
import './assets/css/main.css';
import VueMeta from 'vue-meta';

Vue.config.productionTip = false
Vue.use(MasonryWall);
Vue.use(VueMeta);
new Vue({
  router,
  store,
  vuetify,
  render: function (h) { return h(App) }
}).$mount('#app')
